// refs.tsx
import { useRef } from 'react';

 /////////////////////////////////////////////////////////////////////////////////////////// 
 ///// In quest'area vengono indicati tutti i reference degli elementi dei tours
 ///// essi vengono esportati in un oggetto passato ai sub-elementi nel GlobalContext 
 ///// dell'app chiamata diAppRef
 /////////////////////////////////////////////////////////////////////////////////////////// 

export function useAppRefs() {
  return {
    refSelledProductsSelectCategories: useRef(null),
    refSelledProductsQuantitySwitcher: useRef(null),
    refSelledProductsResetCategories: useRef(null),
    refSelledProductsSaveCategories: useRef(null),
    refCorrectionsTotalQuantity: useRef(null),
    refCorrectionsTotalValue: useRef(null),
    refTotalAfterPreReceipt: useRef(null),
    refTotalWhileService: useRef(null),
    refEarnTimeSwitcher: useRef(null),
    refCorrectionsList: useRef(null),
    refSelledProducts: useRef(null),
    refShowPercentage: useRef(null),
    refResetLayout: useRef(null),
    refEditLayout: useRef(null),
    refChangeDay: useRef(null),
    refDarkMode: useRef(null),
    refEarnTime: useRef(null),
    refFastStat: useRef(null),
    refVersion: useRef(null),
    refColors: useRef(null),
    refFilter: useRef(null),
    refRange: useRef(null),
    refCsv: useRef(null),

    refTopAudiencesCarousel: useRef(null),
    refAudienceNameSection: useRef(null),
    refTopAudiencesButton: useRef(null),
    refAudienceTabsHeader: useRef(null),
    refPotentialAudience: useRef(null),
    refAudienceAddData: useRef(null),
    refAudienceCreate: useRef(null),
    refAudienceSave: useRef(null),
    refAudienceShow: useRef(null),

    refOperationsNotificationDescription: useRef(null),
    refOperationsNotificationAction: useRef(null),
    refOperationsNotificationTitle: useRef(null),
    refOperationsNotificationArea: useRef(null),

    
    refOperationsCouponExpirationDays: useRef(null),
    refOperationsCouponCustomerUsage: useRef(null),
    refOperationsCouponMinAmountCart: useRef(null),
    refOperationsCouponCampaignData: useRef(null),
    refOperationsCouponDescription: useRef(null),
    refOperationsCouponClaimDays: useRef(null),
    refOperationsCouponSubtitle: useRef(null),
    refOperationsCouponMaxUsage: useRef(null),
    refOperationsCouponIsFree: useRef(null),
    refOperationsCouponAction: useRef(null),
    refOperationsCouponTitle: useRef(null),
    refOperationsCouponValue: useRef(null),
    refOperationsCouponArea: useRef(null),
    refOperationsCouponType: useRef(null),

    
  };
}
